import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@dbk/ui-modal';

import Header from './blur-modal-header';
import Footer from './blur-modal-footer';
import Content from './blur-modal-content';

function BlurModal(props) {
  const {
    visible,
    onDone,
    title,
    footerChildren,
    headerChildren,
    hasFooter,
    hasHeader,
    children,
    className,
    size,
    isPymt,
    testID
  } = props;

  return (
    <Modal
      {...props}
      isActive={visible}
      isVisible={visible}
      onClose={onDone}
      size={size}
      header={title}
      content={
        <div>
          {hasHeader && <Header id="text_title_blurModal_test" title={title}>{headerChildren}</Header>}
          <Content isPymt={isPymt}>{children}</Content>
          {hasFooter && <Footer>{footerChildren}</Footer>}
        </div>
      }
      testID={testID}
      className={className}
    />
  );
}

BlurModal.propTypes = {
  visible: PropTypes.bool,
  amount: PropTypes.number,
  headerChildren: PropTypes.node,
  footerChildren: PropTypes.node,
  children: PropTypes.node,
  doneVisible: PropTypes.bool,
  disableDone: PropTypes.bool,
  hasHeader: PropTypes.bool,
  hasFooter: PropTypes.bool,
  size: PropTypes.string,
};

BlurModal.defaultProps = {
  visible: false,
  hasHeader: true,
  hasFooter: false,
  headerChildren: null,
  footerChildren: null,
  disableDone: false,
  size: 'medium',
};

export default BlurModal;
